class RevenueController {
    init() {
        
    }

    show() {
        blurToCurrency(0, [
            '.price'
        ]);
        blurToCurrency(2, [
            '.agent_charges'
        ]);
        blurToPercentage(0, [
            '#transaction_probability'
        ]);
    }
}

window.BC = window.BC || {};
window.BC.revenue = new RevenueController();